import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DashboardDefinitionDTO } from '../../../../../core/services/dashboardsv2.service';
import * as moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-dashboard-export-header',
    templateUrl: './dashboard-export-header.component.html',
    styleUrl: './dashboard-export-header.component.scss',
})
export class DashboardExportHeaderComponent implements OnInit, OnDestroy {
    @Input() public config: DashboardDefinitionDTO;

    public readonly _subscriptions: Subscription = new Subscription();

    public dateTime: string = '';

    public ngOnInit(): void {
        this._subscriptions.add(
            interval(1000)
                .pipe(tap(() => (this.dateTime = moment(new Date()).local().format('YYYY-MM-DD HH:mm:ss'))))
                .subscribe()
        );
    }

    public ngOnDestroy(): void {
        this._subscriptions.unsubscribe();
    }
}
